module.exports = __webpack_public_path__ + "img/charging-station-15.860c475f.svg";